export function compactFingerprint(fingerprint: string): string {
	return fingerprint.replace(/\s+/g, '').toUpperCase();
}
